export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/school/deletePhotoGalleryEventName',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allSchools'],
    })
